export default __webpack_public_path__ + "static/targeting-options-light-mode-18a58f104bb984fc543d0f534e53632e.png";